import fetchApi from '@/utils/fetchApi'
import type { FetchApiErrorOptions } from '@/utils/fetchApi'
import type { DispatchMetadata } from 'shared/src'
import { createConfigurationErrorFormatter } from '@/utils/configurationErrorFormatter'

interface DraftSaveResponse {
  uid: string
  data: DispatchMetadata
}

const errorOptions: FetchApiErrorOptions = {
  formatter: createConfigurationErrorFormatter(),
  title: 'required_fields',
  message: 'please_fill_in_the_following_section(s)_to_test_:',
}

export async function saveDraftConfiguration(dispatchMetadata: DispatchMetadata): Promise<string> {
  const result = await fetchApi<DraftSaveResponse>(
    {
      endpoint: '/api/configurations/create',
      method: 'POST',
      body: { ...dispatchMetadata, draft: true },
    },
    errorOptions,
  )

  if (!result.uid) {
    throw new Error('Failed to save draft configuration')
  }

  return result.uid
}
